import { render, staticRenderFns } from "./RateStudentModal.vue?vue&type=template&id=d08c6762&scoped=true&"
import script from "./RateStudentModal.vue?vue&type=script&lang=js&"
export * from "./RateStudentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08c6762",
  null
  
)

export default component.exports